import {get, post} from "../APIGateWay";

export async function getAchievements(params = {}) {
    return await get(params, '/achievement')
}

export async function claimAchievement(data) {
    return await post(data, '/achievement/claim')
}